export const createMultipartFormData = (payload, files) => {
    const formData = new FormData();
    formData.append("content", JSON.stringify(payload));
    if (files) {
        if (Array.isArray(files)) {
            // Legacy support: array of files all named "attachment"
            for (const file of files) {
                formData.append("attachment", file);
            }
        }
        else {
            // New support: files with specific field names
            Object.entries(files).forEach(([fieldName, fileArray]) => {
                fileArray.forEach((file) => {
                    formData.append(fieldName, file);
                });
            });
        }
    }
    return formData;
};
/**
 * Creates multipart form data specifically for bulk task creation.
 * Based on the task server bulk endpoint requirements from PR #343.
 *
 * The bulk endpoint expects:
 * - Content field with JSON payload containing hierarchical task structure
 * - Support for nested subtasks with recursive structure
 * - File attachments (if any)
 */
export const createMultipartFormDataForBulk = (payload, files) => {
    const formData = new FormData();
    formData.append("content", JSON.stringify(payload));
    if (files && files.length > 0) {
        files.forEach((file) => {
            formData.append("attachment", file);
        });
    }
    return formData;
};
//# sourceMappingURL=createMultipartFormData.js.map